<template>
  <div class="element-input element-car-parts-select">
    <div class="label">{{ label }}</div>
    <template v-if=" tag == 'deleteParts'">
      <element-select v-if="tag == 'deleteParts'" v-model="option.parts" :disabled="option.parts" :items="items" />
      <div class="parts-select-container" v-if="(tag == 'addParts' && parts.value != '기타') || (tag == 'deleteParts' && option.parts != '기타')">
        <ul>
          <li>
            <element-select v-if="tag == 'deleteParts'" v-model="option.year" :disabled="option.year" :items="year.items" />
          </li>
          <li><element-textbox v-if="tag == 'deleteParts'" v-model="option.price" :disabled="option.price"/></li>
        </ul>
        <div class="parts-select-container-etc" v-if="(tag == 'addParts' && parts.value == '기타') || (tag == 'deleteParts' && option.parts == '기타')">
          <element-textbox v-if="tag == 'deleteParts'" v-model="option.etc" :disabled="option.etc" />
        </div>
      </div>
      <button v-if="tag == 'deleteParts'" class="delete" @click="clickDelete">장착품 삭제</button>

    </template>

    <template v-if=" tag == 'addParts'">
      <element-select v-if="tag == 'addParts'" v-model="parts.value" :placeholder="parts.placeholder" :items="items" />
      <div class="parts-select-container" v-if="(tag == 'addParts' && parts.value != '기타') || (tag == 'deleteParts' && option.parts != '기타')">
        <ul>
          <li>
            <element-select v-if="tag == 'addParts'" v-model="year.value" :placeholder="year.placeholder" :items="year.items" />
          </li>
          <li><element-textbox v-if="tag == 'addParts'" v-model="price.value" :placeholder="price.placeholder" type="number"/></li>
        </ul>
      </div>
      <div class="parts-select-container-etc" v-if="(tag == 'addParts' && parts.value == '기타') || (tag == 'deleteParts' && option.parts == '기타')">
        <element-textbox v-if="tag == 'addParts'" v-model="etc.value" :placeholder="etc.placeholder" />
      </div>
      <button v-if="tag == 'addParts'" class="add" @click="clickAdd">장착품 추가</button>
    </template>

    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "tag", "index", "option", "partedate" , "partsdate" ],
  data() {
    return {
      partsList: this.option,
      parts: {
        value: "",
        label: "",
        placeholder: "장착품 선택",
      },
      year: {
        value: "",
        label: "",
        items: [
          /*{ value: "2019년", label: "2019년" }*/
        ],
        placeholder: "장착연도 선택",
      },
      price: {
        value: "",
        label: "",
        placeholder: "예: 50 (만원 단위 입력)",
      },
      etc: {
        value: "",
        label: "",
        placeholder: "장착품명, 장착연도, 장착가액 입력"
      }
    }
  },
  beforeMount() {
  },
  created() {


    if(!this.partsdate || !this.partsdate){
      this.year.items.push(
            { value: "차량 모델을 선택하세요", label: "차량 모델을 선택하세요", placeholder: true }
          )
    }else{
      var end_year = new Date(this.partedate).getFullYear()
      var start_year = Number(String(this.partsdate).substring(0,4)) // new Date(this.partsdate).getFullYear()
      for(var i = 0; i <= (end_year - start_year); i++){
        this.year.items.push(
          { value: (Number(end_year) - i) + "년", label: (Number(end_year) - i) + "년" }
        )
      }
    }


  },
  watch: {
    partsdate: function () {
      this.year.items = []
      if(!this.partsdate || !this.partsdate){
        this.year.items.push(
            { value: "차량 모델을 선택하세요", label: "차량 모델을 선택하세요", placeholder: true }
          )
      }else{
        var end_year = new Date(this.partedate).getFullYear()
        var start_year = Number(String(this.partsdate).substring(0,4)) // new Date(this.partsdate).getFullYear()
        for(var i = 0; i <= (end_year - start_year); i++){
          this.year.items.push(
            { value: (Number(end_year) - i) + "년", label: (Number(end_year) - i) + "년" }
          )
        }
      }
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    },
    clickDelete( ){
      this.$emit( "deleteParts", this.index );
    },
    clickAdd() {
      var o = { parts: "", year: "", price: "", etc: "" };
      if(this.parts.value == '기타'){
        o.parts = this.parts.value;
        o.etc = this.etc.value;
      }
      else{
        o.parts = this.parts.value;
        o.year = this.year.value;
        o.price = this.price.value;
      }
      this.$emit( "addParts", o );

      this.parts.value = "";
      this.year.value = "";
      this.etc.value = "";
      this.price.value = "";
    }
  }
}
</script>
